import { render, staticRenderFns } from "./LiveOtherInfo.vue?vue&type=template&id=2803016f&scoped=true"
import script from "./LiveOtherInfo.vue?vue&type=script&lang=js"
export * from "./LiveOtherInfo.vue?vue&type=script&lang=js"
import style0 from "./LiveOtherInfo.vue?vue&type=style&index=0&id=2803016f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2803016f",
  null
  
)

export default component.exports